import request from '@/utils/request'
const apiPath = '/cust_service/custServiceArchiveTag'
import { downloadBlob } from '@/utils/download'
const custServiceArchiveTagApi = {
  /**
   * 新增【会话管理】
   */
  create(data) {
    return request.post(apiPath, data)
  },
  /**
   * 修改【会话管理】
   */
  update(data) {
    return request.put(apiPath, data)
  },
  /**
   * 分页查询【会话管理】
   */
  fetchList(query) {
    return request.get(apiPath + '/tee', { params: query })
  },
  findOptions(query) {
    return request.get(`${apiPath}/options`, { params: query })
  },
  /**
   * 查看【会话管理】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  /**
   * 删除单个【会话管理】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },
  setIsEnable(data) {
    return request.put(apiPath + '/tee/setIsEnable', data)
  },
  exportExcel(query) {
    return request.get(`${apiPath}/export`, { responseType: 'blob', params: query })
      .then(res => downloadBlob(res, '会话管理.xlsx'))
  },
}
export default custServiceArchiveTagApi
